// Thin I/O wrapper for the getEnergyLabel Cloud Function (EP-Online proxy —
// the public API has no CORS and needs a server-side key, so unlike CBS/BAG
// this source can't be fetched from the browser directly). Intentionally not
// unit-tested; the testable logic lives in energyLabelQueries.js and
// functions/energylabel/parseEnergyLabel.js.
//
// AI-CONTEXT: See docs/features/adress-external-data.md

import firebase from '../../firebase/compat'

// Resolve the registered energy label for a BAG verblijfsobject id.
// Returns the label object or null when none is registered.
const fetchEnergyLabel = async (bagId) => {
    if (!bagId) return null
    const getEnergyLabel = firebase.app().functions('europe-west1').httpsCallable('getEnergyLabel')
    const result = await getEnergyLabel({ bagId })
    return result?.data?.label || null
}

export { fetchEnergyLabel }
